
(function () {
  'use strict';
  var STORE = '';
  var LANDING_PATH = '/pages/newsletter';
  var PRODUCT_PATH = '/pages/morning-milk';
  var VARIANTS = {
    d10: { raw: '49917590798619', pas: '49917590831387', qty: 2, name: '10 Days', now: '₹950', mrp: '₹990', save: 'SAVE ₹40', value: 950 },
    d15: { raw: '45476509483291', pas: '45588393787675', qty: 1, name: '15 Days', now: '₹1,425', mrp: '₹1,485', save: 'SAVE ₹60', value: 1425 },
    d30: { raw: '45476509483291', pas: '45588393787675', qty: 2, name: '30 Days', now: '₹2,850', mrp: '₹2,970', save: 'SAVE ₹120', value: 2850 }
  };
  var plan = 'd30', milkType = 'raw', busy = false;

  function byId(id) { return document.getElementById(id); }
  function track(name, data) {
    if (window.fbq) window.fbq('track', name, data || {});
    if (window.dataLayer && Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({event: name}, data || {}));
  }
  function money(v) { return (v || 0).toLocaleString('en-IN', {style:'currency', currency:'INR', maximumFractionDigits:0}); }

  function showView(which, updateUrl) {
    var landing = byId('landing-view'), product = byId('product-view');
    if (!landing || !product) return;
    var isProduct = which === 'product';
    landing.hidden = isProduct;
    product.hidden = !isProduct;
    document.title = isProduct
      ? 'A2 Desi Cow Milk, Glass Bottle | Pick Your Mornings | Humpy Farms'
      : 'Finally, Milk That Works The Way Milk Is Supposed To | Humpy Farms';
    if (updateUrl) {
      var path = isProduct ? PRODUCT_PATH : LANDING_PATH;
      if (location.pathname !== path) history.pushState({humpyView: which}, '', path);
    }
    window.scrollTo({top:0, behavior:'auto'});
    if (isProduct) {
      paint();
      track('ViewContent', {content_name:'A2 Desi Cow Milk Glass Bottle', currency:'INR'});
    } else {
      track('ViewContent', {content_name:'Humpy Morning Milk', currency:'INR'});
    }
    var pop = byId('popcta');
    if (pop) pop.classList.remove('on');
  }

  document.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-plink]');
    if (cta) {
      e.preventDefault();
      showView('product', true);
      return;
    }
    var back = e.target.closest('[data-blink]');
    if (back) {
      e.preventDefault();
      showView('landing', true);
      return;
    }
  });

  window.addEventListener('popstate', function () {
    showView(location.pathname.replace(/\/+$/, '') === PRODUCT_PATH ? 'product' : 'landing', false);
  });

  window.setPlan = function (p) { if (VARIANTS[p]) { plan = p; paint(); } };
  window.setType = function (t) { if (t === 'raw' || t === 'pas') { milkType = t; paint(); } };

  function paint() {
    var v = VARIANTS[plan];
    var set = function (id, text) { var el = byId(id); if (el) el.textContent = text; };
    set('pnow', v.now); set('pmrp', v.mrp); set('psave', v.save);
    set('t-plan', v.name + ' · one bottle every morning');
    set('t-mrp', v.mrp); set('t-now', v.now);
    var sticky = byId('s-t');
    if (sticky) sticky.innerHTML = v.name + ' · Full Month<b>' + v.now + ' · ₹95 a morning</b>';
    document.querySelectorAll('#product-view .plan').forEach(function (el) { el.classList.toggle('on', el.dataset.plan === plan); });
    document.querySelectorAll('#product-view .mtype').forEach(function (el) { el.classList.toggle('on', el.dataset.mt === milkType); });
  }

  // Product gallery.
  var mainImage = byId('gmain');
  document.querySelectorAll('#gthumbs img').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) { mainImage.src = thumb.src; mainImage.alt = thumb.alt; }
      document.querySelectorAll('#gthumbs img').forEach(function (x) { x.classList.remove('on'); });
      thumb.classList.add('on');
    });
  });

  // Shopify-backed AJAX cart drawer. Cart state comes from Shopify's Ajax Cart API.
  function ensureDrawer() {
    if (byId('hf-cart-drawer')) return;
    var overlay = document.createElement('div');
    overlay.id = 'hf-cart-overlay';
    overlay.addEventListener('click', closeDrawer);
    var drawer = document.createElement('aside');
    drawer.id = 'hf-cart-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Shopping cart');
    drawer.innerHTML = '<div class="hf-cart-head"><h2>Your cart <span id="hf-cart-count"></span></h2><button class="hf-close" type="button" aria-label="Close cart">&times;</button></div><div class="hf-cart-items" id="hf-cart-items"><div class="hf-empty">Loading cart…</div></div><div class="hf-cart-foot"><div class="hf-subtotal"><span>Subtotal</span><span id="hf-cart-subtotal">₹0</span></div><div id="hf-cart-error" class="hf-error" role="alert"></div><a class="hf-checkout" id="hf-checkout" href="/checkout">Checkout securely</a><a class="hf-view-cart" href="/cart">View full cart</a></div>';
    drawer.querySelector('.hf-close').addEventListener('click', closeDrawer);
    drawer.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-hf-change]');
      if (qtyBtn) changeQty(qtyBtn.dataset.key, Number(qtyBtn.dataset.hfChange));
      var removeBtn = e.target.closest('[data-hf-remove]');
      if (removeBtn) updateLine(removeBtn.dataset.key, 0);
    });
    document.body.appendChild(overlay);
    document.body.appendChild(drawer);
  }
  function openDrawer() {
    ensureDrawer();
    byId('hf-cart-overlay').classList.add('open');
    byId('hf-cart-drawer').classList.add('open');
    document.body.classList.add('hf-drawer-open');
    refreshCart();
    var close = byId('hf-cart-drawer').querySelector('.hf-close');
    if (close) close.focus();
  }
  function closeDrawer() {
    if (byId('hf-cart-overlay')) byId('hf-cart-overlay').classList.remove('open');
    if (byId('hf-cart-drawer')) byId('hf-cart-drawer').classList.remove('open');
    document.body.classList.remove('hf-drawer-open');
  }
  function request(url, options) {
    return fetch(url, Object.assign({credentials:'same-origin', headers:{'Accept':'application/json'}}, options || {})).then(function (r) {
      return r.json().catch(function(){ return {}; }).then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Shopify cart request failed.');
        return data;
      });
    });
  }
  function refreshCart() {
    request('/cart.js').then(renderCart).catch(function (err) { var e = byId('hf-cart-error'); if(e) e.textContent = err.message; });
  }
  function renderCart(cart) {
    var items = byId('hf-cart-items');
    if (!items) return;
    byId('hf-cart-count').textContent = '(' + cart.item_count + ')';
    byId('hf-cart-subtotal').textContent = money(cart.total_price / 100);
    byId('hf-checkout').href = '/checkout';
    if (!cart.items || !cart.items.length) {
      items.innerHTML = '<div class="hf-empty">Your cart is empty.</div>';
      return;
    }
    items.innerHTML = cart.items.map(function (item, i) {
      var image = item.image ? '<img src="' + String(item.image).replace(/"/g, '&quot;') + '" alt="">' : '<div></div>';
      var title = String(item.product_title || item.title).replace(/[&<>"]/g, function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div style="font-size:12px;color:#777">' + item.variant_title + '</div>' : '';
      return '<div class="hf-cart-item">' + image + '<div><div class="hf-item-title">' + title + '</div>' + variant + '<div class="hf-item-price">' + money(item.final_price / 100) + '</div><div class="hf-qty"><button type="button" data-hf-change="-1" data-key="' + item.key + '" aria-label="Decrease quantity">−</button><span>' + item.quantity + '</span><button type="button" data-hf-change="1" data-key="' + item.key + '" aria-label="Increase quantity">+</button><button type="button" class="hf-remove" data-hf-remove="1" data-key="' + item.key + '">Remove</button></div></div></div>';
    }).join('');
  }
  function changeQty(key, delta) {
    request('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({id:key, quantity:Math.max(0, getQuantity(key) + delta)})})
      .then(renderCart).catch(showCartError);
  }
  function getQuantity(key) {
    var item = (window.__humpyCartItems || []).find(function (x) { return x.key === key; });
    return item ? item.quantity : 1;
  }
  function updateLine(key, quantity) {
    request('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({id:key, quantity:quantity})})
      .then(renderCart).catch(showCartError);
  }
  function showCartError(err) { var e = byId('hf-cart-error'); if (e) e.textContent = err.message || 'Please try again.'; }
  // Wrap renderCart to retain line keys/quantities for +/-.
  var renderCartBase = renderCart;
  renderCart = function(cart) { window.__humpyCartItems = cart.items || []; renderCartBase(cart); };

  window.buy = function (btn) {
    if (busy) return;
    var v = VARIANTS[plan];
    busy = true;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding to cart…'; }
    var payload = { items: [{ id: Number(v[milkType]), quantity: v.qty }] };
    request('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(payload)})
      .then(function (added) {
        track('AddToCart', {content_name:'A2 Desi Cow Milk ' + v.name, content_ids:[v[milkType]], content_type:'product', value:v.value, currency:'INR'});
        openDrawer();
      })
      .catch(function (err) { showCartError(err); openDrawer(); })
      .finally(function () { busy = false; if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart 👉'; } });
  };

  // Sticky CTA visibility.
  var sticky = byId('sticky');
  if (sticky) {
    function checkSticky() {
      if (window.scrollY > window.innerHeight) sticky.classList.add('on');
      else sticky.classList.remove('on');
    }
    window.addEventListener('scroll', checkSticky, {passive:true});
    checkSticky();
  }

  // Start view based on URL so /pages/morning-milk works after a refresh too.
  var initialProduct = location.pathname.replace(/\/+$/, '') === PRODUCT_PATH;
  showView(initialProduct ? 'product' : 'landing', false);
  // Do not add an extra PageView on each transition; the existing pixel gets ViewContent events.
})();
